import { useCallback, useMemo } from 'react'

import { ProjectDocument } from '../../../api/resources/project'
import { Select } from '../../common/Select/Select'
import { MainPanel } from '../../layout/main-panel/MainPanel'

interface ReportsFiltersSlotProps {
  documentsList?: ProjectDocument[]
  onSelectCategory?: (category: string | null) => void
}

export const ReportsFiltersSlot = ({
  documentsList,
  onSelectCategory,
}: ReportsFiltersSlotProps) => {
  const categories = useMemo(() => {
    if (!documentsList) return []
    const uniqueCategories = new Set<string>()
    documentsList.forEach(document => {
      if (document.category) {
        uniqueCategories.add(document.category)
      }
    })
    return Array.from(uniqueCategories)
  }, [documentsList])

  const handleSelectCategory = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      const selectedCategory =
        event.target.value === 'all' ? null : event.target.value
      if (onSelectCategory) {
        onSelectCategory(selectedCategory)
      }
    },
    [onSelectCategory],
  )

  return (
    <MainPanel.Slot>
      <MainPanel.SlotItem>
        <Select onChange={handleSelectCategory}>
          <option value="all">All Categories</option>
          {categories.map(category => (
            <option key={category} value={category}>
              {category}
            </option>
          ))}
        </Select>
      </MainPanel.SlotItem>
    </MainPanel.Slot>
  )
}
